// extracted by mini-css-extract-plugin
export default {"flag":"CountryFlag_flag__5l2Vb"};